<script>
import { mapState, mapActions } from 'vuex';
/* components */
import UserBio from '@/components/UserBio';
import FullScreenOverlay from '@/components/FullScreenOverlay';
import Button from '@/components/Button';
import InputBlock from '@/components/InputBlock';

/* tools */
import { goTo } from '@/scripts/methods';
import { setProfile, getProfile } from '@/scripts/api/account';
import Avatar from '@/components/Avatar';

export default {
  name: 'FillProfile',
  components: {
    Avatar,
    Button,
    FullScreenOverlay,
    InputBlock,
    UserBio,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { user } = this;
    const { firstName, lastName } = user;

    return {
      firstName,
      lastName,
    };
  },
  computed: {
    ...mapState(['']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({ setUser: 'setUser' }),
    save() {
      const { bio, firstName, lastName } = this;
      const to = '/onboarding/connect-game';
      const payload = {
        ...bio,
        firstName,
        lastName,
      };

      setProfile(payload).then(() => {
        getProfile().then(user => {
          this.setUser(user);
          this.goTo(to);
        });
      });
    },
    updatePayload(bio) {
      this.bio = bio;
    },
    goTo,
  },
};
</script>

<template>
  <FullScreenOverlay>
    <div class="profile">
      <div class="profile__content">
        <div class="profile__top">
          <div class="profile__title">User Profile</div>
          <div class="profile__skip">
            <Button
              to="/onboarding/connect-game"
              class="link-white"
              @click="save"
            >
              Skip
            </Button>
          </div>
        </div>
        <div class="profile__body">
          <div class="profile__row profile__row--upload">
            <div class="profile__upload">
              <!-- upoad avatar -->
              <Avatar :editable="true" />
            </div>
          </div>

          <!-- form -->
          <div class="profile__row profile__row--form">
            <div class="form">
              <!-- firstName -->
              <div class="form__row">
                <InputBlock
                  :forceValue="firstName"
                  @input="val => (firstName = val)"
                  placeholder="First name…"
                >
                  <template #label>
                    <span class="label">First name</span>
                  </template>
                </InputBlock>
              </div>

              <!-- lastName -->
              <div class="form__row">
                <InputBlock
                  :forceValue="lastName"
                  @input="val => (lastName = val)"
                  placeholder="Last name…"
                >
                  <template #label>
                    <span class="label">Last name</span>
                  </template>
                </InputBlock>
              </div>

              <!-- // -->
              <div class="form__row">
                <UserBio v-if="user" :user="user" @change="updatePayload" />
              </div>
              <!-- // -->

              <!-- save -->
              <div class="form__row form__row--btn">
                <Button class="blue m-290" @click="save">
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </FullScreenOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.profile {
  padding-top: 70px;
  display: flex;
  justify-content: center;
  width: 100%;

  &__content {
    max-width: 570px;
    width: 100%;
  }

  &__title {
    font-family: Poppins-Light;
    font-size: 36px;
    line-height: 51px;
    color: #ffffff;
    text-align: center;
    margin: 0;
  }

  &__top {
    margin-bottom: 30px;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-shrink: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
  }

  &__skip {
    display: flex;
    margin-bottom: 8px;
  }

  &__row {
    & + &--form {
      margin-top: 30px;
    }
  }

  &__upload {
    width: 100px;
    height: 100px;
  }
}

.form {
  width: 100%;

  &__row {
    width: 100%;

    & + & {
      margin-top: 30px;
    }

    & + &--btn {
      margin-top: 50px;
    }

    &--btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
}

.label {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: $mobile) {
  .profile {
    padding-top: 0;

    &__title {
      font-size: 21px;
      line-height: 29px;
    }

    &__row {
      & + &--form {
        margin-top: 40px;
      }
    }

    &__skip {
      margin-bottom: 0;
    }
  }

  .label {
    font-size: 12px;
    line-height: 17px;
  }

  .form {
    &__row {
      & + &--btn {
        margin-top: 40px;
      }
    }
  }
}
</style>
